export const publicApiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (detail?.status === "clarification_required") {
    return { kind: "clarification", message: "Für eine verlässliche Auswertung fehlen uns noch einzelne Angaben oder Antworten sind nicht eindeutig. Bitte prüfen Sie Ihre Angaben noch einmal." };
  }
  if (detail?.status === "mail_disabled") {
    return { kind: "mail_disabled", message: "Der Versand ist derzeit nicht verfügbar." };
  }
  return { kind: "technical", message: "Die Anfrage konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut." };
};
